declare global {
  interface Window {
    __RP_HOMEPAGE_STARTUP__?: {
      startedAt: number;
      fallback: boolean;
      timer: number;
    };
  }
}

// These rules and the synchronous script are in the initial homepage head,
// before its content can paint. Without JavaScript the public HTML stays visible.
export const HOMEPAGE_STARTUP_STYLES = `
#homepage-startup { display: none; }
html[data-homepage-startup="pending"] { overflow: hidden; }
html[data-homepage-startup="pending"] #root { display: none; }
html[data-homepage-startup="pending"] #homepage-startup { display: block; }
`;

export const HOMEPAGE_STARTUP_SCRIPT = `(function () {
  if (window.location.pathname !== "/" || window.__RP_HOMEPAGE_STARTUP__) return;
  var state = { startedAt: Date.now(), fallback: false, timer: 0 };
  window.__RP_HOMEPAGE_STARTUP__ = state;
  document.documentElement.setAttribute("data-homepage-startup", "pending");
  state.timer = window.setTimeout(function () {
    state.fallback = true;
    document.documentElement.removeAttribute("data-homepage-startup");
  }, 10000);
})();`;

export function homepageFallbackWasShown(): boolean {
  return window.__RP_HOMEPAGE_STARTUP__?.fallback === true;
}

/** Claim the boot timer before React can replace the prerendered root. */
export function prepareHomepageStartup(root: HTMLElement): void {
  const state = window.__RP_HOMEPAGE_STARTUP__;
  if (state) {
    window.clearTimeout(state.timer);
    // Continue the same animation across the static-to-React handoff.
    document.documentElement.style.setProperty("--plutus-startup-delay", `${state.startedAt - Date.now()}ms`);
  } else if (root.hasAttribute("data-homepage-prerender")) {
    // CSP may block the inline guard while allowing the application bundle.
    // The visitor has already seen the current homepage; never replace it with V2.
    window.__RP_HOMEPAGE_STARTUP__ = { startedAt: Date.now(), fallback: true, timer: 0 };
  }
}

/** Called in a layout effect, only after the React loading/page tree commits. */
export function finishHomepageStartup(): void {
  document.documentElement.removeAttribute("data-homepage-startup");
  document.getElementById("homepage-startup")?.remove();
}
